/**
 * Satın alma ayarları.
 *
 * NEDEN AYRI DOSYA: `playBilling.ts` ve `revenuecat.ts` bu değerleri
 * `import.meta.env`den okuyordu. ts-jest `import.meta`yı derleyemiyor, yani
 * iki dosya da test ortamında IMPORT EDİLEMİYORDU — gerçek paranın geçtiği
 * yol tam da bu yüzden sınanamıyordu.
 *
 * Okumalar buraya taşındı, ifadeler DEĞİŞMEDİ (`|| ''` dahil). Kardeşleri:
 * `lib/clientConfig.ts`, `lib/pushConfig.ts`, `lib/liveUpdateConfig.ts`.
 *
 * Adres birleştirme ve başlık kurma BİLEREK burada değil — onlar davranış,
 * kendi dosyalarında kaldılar.
 */

/** RevenueCat iOS anahtarı. */
export const RC_IOS_KEY: string = import.meta.env.VITE_RC_IOS_KEY || ''

/** RevenueCat Android anahtarı. */
export const RC_ANDROID_KEY: string = import.meta.env.VITE_RC_ANDROID_KEY || ''

/** Geliştirme kipi — RevenueCat kayıt ayrıntısını belirliyor. */
export const IS_DEV: boolean = import.meta.env.DEV

/** Satın alma doğrulaması bu projenin edge function'ına gidiyor. */
export const SUPABASE_URL: string = import.meta.env.VITE_SUPABASE_URL

/** Edge function çağrısının yetki başlığı. */
export const SUPABASE_ANON_KEY: string = import.meta.env.VITE_SUPABASE_ANON_KEY
